// import moment from "moment";
import axios from "axios";
import { pgiUrl, url } from "../../src/Values/constants";
import {
  showSnackbarAction,
  setFilterObject,
  setInitialParams
} from "../Redux/actions";
import { convertToFilterString } from "../Values/utils";
import axiosHandler from "./axiosHandler";

export const createOrder = async (gst:any,soid:any,offerPrice:any,originalPrice:any,packageId:any,originalToken:any,isRecurringPay?:any,tag?:any) => {
    const apiUrl = url+"/pgi/createOrder";
  
    const payload = {
          oid: soid,
          offerPrice: offerPrice,
          originalPrice: originalPrice,
          packageId:packageId,
          isRecurringPay:isRecurringPay,
          tag:tag,
          gst:gst
    };
  
    try {
      // console.log(" payload:", payload);

      // localStorage.setItem("section", JSON.stringify(payload));
  
      const response = await axiosHandler.post(apiUrl, payload);

      // console.log("response",response.data.responsePayloadData.pgiRefId)
      const data = response.data;
        // Extract pgiRefId from the response
        const pgiRefId = data.responsePayloadData?.pgiRefId;
        if (pgiRefId) {
            const paymentUrl = pgiUrl+`/PGI/PaymentGateway?qid=${pgiRefId}&source=MB`;

            // Parse the original URL
            const url = new URL(originalToken);

            // Update the `redirect_uri` parameter
            url.searchParams.set("redirect_uri", paymentUrl);

            // Get the updated token URL
            const updatedToken = url.toString();

            // console.log(updatedToken);

            // console.log("Generated Payment URL:", paymentUrl);
            window.location.href = updatedToken;
        }
     

    } catch (error:any) {
      // Handle errors
      console.error("Error fetching responses:", error.response || error);
      throw error;
    }
  };


  export const readOrderHistory = async (
    serviceIds:any,
    soId:any,
    pageNo:any,
    setNextPageAvailable: (data: any) => void,
    success?:any
  ) => {
    // const apiUrl = url+"/pgi/readProductList";
    let st
if(success===true){
st='s'
}
    const apiUrl =url+"/pgi/readOrderHistory"

    const payload = {
      pageNo: pageNo, 
      soId: soId, 
      serviceIds: serviceIds,
      st
    };
  
    try {
      // console.log("readOrderHistory payload:", payload);
  
      const response = await axiosHandler.post(apiUrl, payload);

      // console.log("response",response.data.responsePayloadData.pgiRefId)
      const data = response.data.data;
// console.log("readOrderHistory data",data.dataList)
      // setHistory(data)
      setNextPageAvailable(data.nextAvailable)
      return data.dataList

    } catch (error:any) {
      // Handle errors
      console.error("Error fetching responses:", error.response || error);
      throw error;
    }
  };

  export const pgiAutoLogin = async (
    oid:any,
    setToken: (data: any) => void,
  ) => {
    // const apiUrl = url+"/pgi/readProductList";

    const apiUrl =url+"/pgi/callAutoLoginFun"

    const payload = {
      userId: oid, 
    };
  
    try {
      // console.log("readOrderHistory payload:", payload);
  
      const response = await axiosHandler.post(apiUrl, payload);

      // console.log("response",response.data.responsePayloadData.pgiRefId)
      const data = response.data;
      // console.log("Token data",data)
      
      setToken(data)
      // return data.dataList

    } catch (error:any) {
      // Handle errors
      console.error("Error fetching responses:", error.response || error);
      throw error;
    }
  };


  export const creditHistory = async (
    serviceIds:any,
    soId:any,
    setTotalBalance: (data: any) => void,
    setExPackage?: (data: any) => void,
    setTime?: (data: any) => void,
  ) => {
    // const apiUrl = url+"/pgi/readProductList";
   
    const apiUrl =url+"/pgi/creditHistory"

    const payload = { 
      soId: soId, 
      serviceIds: serviceIds,
      st:"s",
    };
  
    try {
      // console.log("creditHistory payload:", payload);
  
      const response = await axiosHandler.post(apiUrl, payload);

      // console.log("response",response.data.responsePayloadData.pgiRefId)
      const data = response.data.data;
// console.log("creditHistory data",data)
      // setHistory(data)
      // Safely update state variables
    if (data.nextSevenDaysCount) {
      setExPackage?.(data.nextSevenDaysCount || ""); // Use optional chaining
      setTime?.(data.nextSevenDaysValue|| "");
      // setTotalBalance(data.balanceAmount);
    } else {
      console.warn("No data returned from API.");
    }
      setTotalBalance(data.balanceAmount)
      return data.dataList

    } catch (error:any) {
      // Handle errors
      console.error("Error fetching responses:", error.response || error);
      throw error;
    }
  };

  export const recurringPaySetup = async (
    organization_id:any,
    soId:any,
    orderId:any,
    package_id: any,
    price: any,
    recurr_pack:any,
    recurr_amount:any,
    responseGst:any,
  ) => {
    // const apiUrl = url+"/pgi/readProductList";
   
    const apiUrl =url+"/pgi/recurringSetup"

    const payload = {
      organization_id:organization_id,
      orderId:orderId,
      package_id:package_id,
      oid:soId,
      recurringStatus:"ACTIVE",
      lastPayState:"50004",
      price:price,
      recurr_pack:recurr_pack,
      recurr_amount:recurr_amount,
      responseGst:responseGst
    };
  
    try {
      // console.log("recurringSetup payload:", payload);
  
      const response = await axiosHandler.post(apiUrl, payload);

      const data = response.data;
      // console.log("recurringSetup data:", data);
      return

    } catch (error:any) {
      // Handle errors
      console.error("Error fetching responses:", error.response || error);
      throw error;
    }
  };

  export const recurringHistory = async (
    soId:any,
    parentOrderId:any,
    serviceIds:any
  ) => {
   
    const apiUrl =url+"/pgi/recurringHistory"

    const payload = {
      parentOrderId:parentOrderId,
      soId:soId,
      serviceIds:serviceIds,
    };
  
    try {
      // console.log("recurringHistory payload:", payload);
  
      const response = await axiosHandler.post(apiUrl, payload);

      const data = response.data.data;
      // console.log("recurringHistory data:", data);
      return data

    } catch (error:any) {
      // Handle errors
      console.error("Error fetching responses recurringHistory:", error.response || error);
      throw error;
    }
  };

  export const recurringOrders = async (
    soId:any,
    serviceIds:any,
  ) => {
   
    const apiUrl =url+"/pgi/recurringOrders"

    const payload = {
      soId:soId,
      serviceIds: serviceIds,
    };
  
    try {
  
      // console.log("recurringOrders payload:", payload);
      // console.log("recurringOrders apiUrl:", apiUrl);

      const response = await axiosHandler.post(apiUrl, payload);

      const data = response.data.data;
      // console.log("recurringOrders data:", data);
      return data

    } catch (error:any) {
      // Handle errors
      console.error("Error fetching responses recurringOrders:", error.response || error);
      throw error;
    }
  };

  export const cancleRecurring = async (
    Id:any,
    soid:any,
    setLoad?: (data: boolean) => void,
  ) => {
    if(setLoad){setLoad(true)}
   
    const apiUrl =url+"/pgi/cancleRecurring"

    const payload = {
      orderId:Id,
      soid:soid
    };
  
    try {
  
      const response = await axiosHandler.post(apiUrl, payload);

      const data = response.data;
      // console.log("cancleRecurring data:", data);
      // return data
      {data.message === "Data updated successfully" &&
          showSnackbarAction(data.message, "success")
         window.location.reload();
      }
      {data.message === "Failed to Update. Please try again later" &&
        showSnackbarAction(data.message, "error")
    }
if(setLoad){setLoad(false)}

    } catch (error:any) {
      // Handle errors
      if(setLoad){setLoad(false)}
      console.error("Error fetching responses recurringOrders:", error.response || error);
      throw error;
    }
  };

  
const taginsert = async (tag: String, recurringPackageId: String, recurringPackageAmount: any, oid: String, organizationId: String) => {
  const apiUrl = url + "/miscellaneous/tagUpdate";
  const payload = {
    free_trial: tag,
    actual_packId: recurringPackageId,
    actual_amount: recurringPackageAmount,
    orgId: organizationId,
    oid: oid,
  };
  // console.log("sendMail--payload",payload)
  try {
    const response = await axiosHandler.post(apiUrl, payload);
    //  console.log("miscellaneous done response",response)
    return response.data.data
  } catch (error: any) {
    // Handle errors
    // console.error("Error fetching responses:", error.response || error);
    throw error;
  }
};

export const readproPackagePurchaseViaPGI = async (user_super_oid: string, packageId: string, dispatcher: any, isMobile: boolean, isRecurringPay?: string, gst?: string, initialParams?: any) => {

  try {
    const readproPackagePurchaseViaPGIUrl = url + "/pgi/readproPackagePurchaseViaPGI";

    const readproPackagePurchaseViaPGIPayload = {
      user_super_oid,
      packageId,
      isMobile,
      isRecurring: isRecurringPay,
      gstNo: gst
    };

    // console.log("gstss",{
    //   user_super_oid,
    //   packageId,
    //   isMobile,
    //   isRecurring: isRecurringPay,
    //   gstNo: gst
    // })
    const readproPackagePurchaseViaPGIResponse: any = await axiosHandler.post(readproPackagePurchaseViaPGIUrl, readproPackagePurchaseViaPGIPayload);

    const paymentUrl =  pgiUrl + readproPackagePurchaseViaPGIResponse.data.data.paymentUrl;
    const autoLoginToken = readproPackagePurchaseViaPGIResponse.data.data.autoLoginToken;

    // Parse the original URL
    const pgiRedirectUrl = new URL(autoLoginToken);

    // Update the `redirect_uri` parameter
    pgiRedirectUrl.searchParams.set("redirect_uri", paymentUrl);

    // Get the updated token URL
    const updatedToken = pgiRedirectUrl.toString();

    // console.log(updatedToken);

    // console.log("Generated Payment URL:", paymentUrl);
    window.location.href = updatedToken;

  } catch (error: any) {
    if (initialParams) {
      dispatcher(setInitialParams({ ...initialParams, packageId: "" }));
    }
    if(isMobile){
      alert(error?.response?.data?.message ? error.response.data.message : "An error occured, please try again");
    }
    dispatcher(showSnackbarAction(error?.response?.data?.message ? error.response.data.message : "An error occured, please try again", "error"));

  }
}